import PropTypes from 'prop-types';
import React from 'react';

export function ActionableTableCell({ children, customStyles, onClick }) {
  return (
    <>
      <div
        style={customStyles}
        className="actionable-table-cell"
        onClick={onClick}
      >
        {children}
      </div>
      <style jsx>{`
        .actionable-table-cell {
          height: 45px;
          cursor: pointer;
        }
      `}</style>
    </>
  );
}

ActionableTableCell.propTypes = {
  children: PropTypes.any,
  customStyles: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

ActionableTableCell.defaultProps = {
  customStyles: {},
};
